import { motion } from "framer-motion";
import { Store, ShoppingBasket, Building2, Warehouse, Factory, ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const SECTORS = [
  { icon: Store, name: "Padarias & Lojas de Bairro", desc: "Proteção de frotas compactas com resposta rápida no entorno." },
  { icon: ShoppingBasket, name: "Supermercados de Pequeno e Médio Porte", desc: "Monitoramento proporcional ao tamanho da operação, sem custo excessivo." },
  { icon: Building2, name: "Supermercados de Grande Porte", desc: "Cobertura de múltiplos perímetros e relatórios gerenciais recorrentes." },
  { icon: Warehouse, name: "Atacadistas & Atacarejos", desc: "Gestão de alto giro de carrinhos com assistência técnica contínua." },
  { icon: Factory, name: "Hipermercados", desc: "Operação em escala com prospecção de ativos e regularização de inventário." },
];

export const Areas = () => (
  <section id="atuacao" className="relative py-24 sm:py-32" data-testid="areas-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:items-start">
        <div className="lg:sticky lg:top-28">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE }}
          >
            <p className="font-tech text-xs font-bold uppercase tracking-[0.25em] text-[#06B6D4]">Áreas de atuação</p>
            <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
              Da padaria da esquina ao hipermercado.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-slate-400">
              Qualquer operação que dependa de carrinhos pode transformar perda em economia. Adaptamos a operação ao
              porte do seu negócio.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
            className="relative mt-10 overflow-hidden rounded-2xl border border-white/10"
          >
            <img
              src="/assets/warehouse.jpg"
              alt="Centro de distribuição atendido pela ResgateCar"
              loading="lazy"
              className="h-72 w-full object-cover sm:h-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A8A]/90 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 font-tech text-[10px] uppercase tracking-[0.2em] text-slate-300">
              Operação em escala · Atacado & varejo
            </div>
          </motion.div>
        </div>

        <div className="space-y-4">
          {SECTORS.map((s, i) => (
            <motion.div
              key={s.name}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: EASE }}
              className="group flex items-center gap-5 rounded-2xl border border-white/10 bg-[#1B3579] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#06B6D4]/40"
              data-testid={`sector-card-${i}`}
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-[#1E3A8A] text-[#06B6D4] transition-colors duration-300 group-hover:border-[#06B6D4]/40">
                <s.icon className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-display text-lg font-bold tracking-tight">{s.name}</h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-400">{s.desc}</p>
              </div>
              <ArrowUpRight className="h-5 w-5 shrink-0 text-slate-600 transition-all duration-300 group-hover:text-[#A3E635]" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Areas;
